import React from 'react';
import Button from './Button';
import {BreadcrumbLogo} from './Vectors';
import {History, HistoryEvent} from '../router/History';

import '../css/ui/Breadcrumb.scss';
import Router from '../router/Router';


export default class Breadcrumb extends React.Component
{
	history = new History();

	state = {
		path: '',
	}

	componentDidMount()
	{
		this.history.on(HistoryEvent.CHANGE, this._historyChange);
		setTimeout(this._historyChange, 200);
	}
	private _historyChange = () => {
		this.setState({path: this.history.path});
	}

	render()
	{
		let items = [];
		if(Router.inited)
		{
			console.log(this.state.path, Router.showBreadcrumb(this.state.path));
			if(Router.showBreadcrumb(this.state.path))
			{
				items = Router.breadcrumb(this.state.path);
			}
		}

		let classes = ['breadcrumb'];
		if(items.length == 0) classes.push('hidden');

		return (
			<div className={classes.join(' ')}>
				<div className='content padding'>
					{
						items.map((e, i)=>{
							return (<BreadcrumbItem key={i} first={(i === 0)} label={e.label} path={e.path}></BreadcrumbItem>)
						})
					}
				</div>
			</div>
		)
	}
}

class BreadcrumbItem extends React.Component<{first?:Boolean, label:string, path:string}>
{
	render()
	{

		return (
			<Button plain={true} to={this.props.path}>
				<span className='icon'>
					{(this.props.first)?(<BreadcrumbLogo></BreadcrumbLogo>):'>'}
				</span>
				{this.props.label}
			</Button>
		)
	}
}